import axios from 'axios'
// import MockAdapter from 'axios-mock-adapter'

import { isBrowser, isNode } from '~src/env'

class NetworkClient {
  static DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }

  // _MockServer = null
  // get MockServer () {
  //   if (!this._MockServer) {
  //     this._MockServer = new MockAdapter(this.transport)
  //   }
  //   return this._MockServer
  // }

  constructor ({
    baseURL = '/',
    timeout = 10000,
    requestInterceptors = [],
    responseInterceptors = []
  }) {
    this.urls = {
      lookups: {},
      upload: {}
    }

    this.transport = axios.create({
      baseURL,
      timeout,
    })

    requestInterceptors.forEach((interceptor) => {
      this.transport.interceptors.request.use(interceptor)
    })

    responseInterceptors.forEach((interceptor) => {
      this.transport.interceptors.response.use(interceptor)
    })
  }

  configure ({
    baseURL,
    headers,
    timeout,
  }) {
    this.transport.defaults = {
      baseURL,
      headers,
      timeout,
    }
  }

  get (url, ...args) { return this.transport.get(url, ...args) }
  put (url, data, ...args) { return this.transport.put(url, data, ...args) }
  post (url, data, ...args) { return this.transport.post(url, data, ...args) }
  delete (url, data, ...args) { return this.transport.delete(url, data, ...args) }
  head (url, data, ...args) { return this.transport.head(url, data, ...args) }
  option (url, data, ...args) { return this.transport.option(url, data, ...args) }
}

export const handleHttpError = (error) => {
  if (isBrowser && !isNode) {
    console.error(error)
  }
}

export default new NetworkClient({})
